/**
 * all actions for right menu notifications
 *
 * Created by Heesien on 17/08/18
 */

import C from '../constants'

// action to hide/show the loader for the notifications
export const showNotificationsLoader = booleanVal => {
    return {
        type: C.SET_NOTIFICATIONS_LOADER,
        payload: booleanVal
    }
}

// action to set the notifications data
export const setNotificationsData = objectVal => {
    return {
        type: C.SET_NOTIFICATIONS_DATA,
        payload: objectVal
    }
}

export const removeNotificationsPendingAction = pendingActionId => {
    return {
        type: C.REMOVE_NOTIFICATIONS_PENDING_ACTION,
        payload: pendingActionId
    }
}


/* -----------------------------------------------------------------------------
    ACTIONS CREATORS
----------------------------------------------------------------------------- */
// call the action to fetch the data
// NOTE: this will be picked up by the notifications saga (sagas/notifications.js)
export const getNotificationsData = () => {
    return {
        type: C.FETCH_NOTIFICATIONS_DATA,
    }
}

// call the action to dismiss a notification
// NOTE: this will be picked up by the notifications saga (sagas/notifications.js)
export const dismissNotificationRequest = id => {
    return {
        type: C.DISMISS_NOTIFICATION,
        payload: id
    }
}



// WEBPACK FOOTER //
// ./src/actions/notificationsActions.js